module.exports = __webpack_public_path__ + "img/Stal-line.8b18702b.svg";